export default __webpack_public_path__ + "static/media/002-umbrella.36182a5b.png";